{
  "version": "fd3e9da0cd64fdae584d11cb13a46450a505fd19",
  "deploy_image_tag": "fd3e9da0cd64fdae584d11cb13a46450a505fd19"
}
